// FLAGS: none
// Provider shell: the Google OAuth client id, the React Query cache, the router and the toast host.
import { GoogleOAuthProvider } from "@react-oauth/google";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router";
import { Toaster } from "sonner";
import { env } from "@src/env";
import queryClient from "@src/lib/queryClient";
import router from "@src/routes";

const App = () => (
  <GoogleOAuthProvider clientId={env.REACT_APP_GOOGLE_CLIENT_ID}>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster richColors position="top-center" />
    </QueryClientProvider>
  </GoogleOAuthProvider>
);

export default App;
